import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import {
  Button,
  Container,
  Dimmer,
  Dropdown,
  Grid,
  Header,
  Loader,
  Menu,
  Segment,
} from 'semantic-ui-react';
import clone from 'clone';
import { replace } from 'react-router-redux';
import { connect } from 'react-redux';
import { fetchM } from '../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
import NavBar from '../../../components/NavBar';
import SortablePackagePricing from '../../../components/Sortable/SortablePackagePricing';
import { editRoutes } from '../navigations';
import { isVietnamCompany } from '../../../utils/vietnam';
import config from '../../../../config';

class PackagePricing extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    id: PropTypes.string,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    data: PropTypes.shape(),
    onCheck: PropTypes.func,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    auth: PropTypes.shape({
      company: PropTypes.object,
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const projectData = props.data || {};
    const projectToken = props.token || '';
    const loading = props.loading;
    const menuIsTab = window.innerWidth <= 590;
    return {
      loading,
      menuIsTab,
      oriProjectData: clone(projectData),
      projectData,
      projectToken,
    };
  }
  constructor(props) {
    super(props);
    const state = PackagePricing.getPropsToState(props);
    this.state = {
      ...state,
      data: [],
      hasChanges: false,
      isEditing: false,
      token: '',
    };
  }
  componentDidMount() {
    this.fetchProjectPackagePricings();
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = PackagePricing.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setLoading = (loading = false) => new Promise((res) => {
    this.setState({ loading }, () => {
      res(loading);
    });
  })
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  getPackagePricingOptions = () => {
    const { data } = this.state;
    const options = [{
      text: 'Disabled',
      value: '',
    }];
    data.forEach((d) => {
      if (d.id !== '') {
        options.push({
          disabled: (
            !d.isEnabled ||
            moment(d.scheduleEndAt).unix() < moment().unix() // expired package
          ),
          text: d.name,
          value: d.id,
        });
      }
    });
    return options;
  }
  tidyData = (datas) => {
    const newDatas = [];
    datas.forEach((d) => {
      const data = d;
      // remove timezone from date object (because API server has default timezone set)
      if (data.scheduleStartAt) data.scheduleStartAt = `${moment(data.scheduleStartAt).format('YYYY-MM-DDTHH:mm:ss')}Z`;
      if (data.scheduleEndAt) data.scheduleEndAt = `${moment(data.scheduleEndAt).format('YYYY-MM-DDTHH:mm:ss')}Z`;
      newDatas.push(data);
    });
    return newDatas;
  }
  async fetchProjectPackagePricings() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/package_pricings/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      await this.setComponentState({
        token,
        data: data || [],
      });
    }
    await this.setLoading(false);
  }
  async updateProjectPackagePricings() {
    await this.setLoading(true);
    const { store } = this.context;
    const tidyData = this.tidyData(this.state.data);
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/package_pricings/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(tidyData),
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      await this.setComponentState({
        data: data || [],
        hasChanges: false,
      });
      this.handleOnCheck(false);
      const hasBackgroundQueue = res.headers.get('X-Has-Background-Queue');
      let message = 'Pricing package successfully updated';
      if (hasBackgroundQueue === 'true') message = 'Pricing package template successfully updated, Units are still being updated in the background, you will recevied an email upon completion.';
      await store.dispatch(flashSuccessMessage({ header: 'Update Success', message, autoHideDuration: 8000 }));
    }
    await this.setLoading(false);
  }
  async deleteProjectPackagePricing(id, callBack) {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/package_pricings/${id}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await store.dispatch(flashSuccessMessage({ header: 'Delete Success', message: 'Pricing package successfully deleted' }));
    }
    await this.setLoading(false);
    if (callBack) callBack();
  }
  async deleteProjectPackagePricingItem(id, itemID, callBack) {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/package_pricings/${id}/items/${itemID}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await store.dispatch(flashSuccessMessage({ header: 'Delete Success', message: 'Pricing package successfully deleted' }));
    }
    await this.setLoading(false);
    if (callBack) callBack();
  }
  async updateProject(data) {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.projectToken,
        },
        body: JSON.stringify(data),
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const projectData = await res.json();
      await this.setComponentState({
        projectData: projectData || this.props.data,
      });
      await store.dispatch(flashSuccessMessage({ header: 'Update Success', message: 'Default pricing package successfully updated' }));
    }
    await this.setLoading(false);
  }
  async bulkManageUnitsPP(isAdd, id) {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/package_pricings/${id}/apply_units/`, {
        credentials: 'include',
        method: isAdd ? 'POST' : 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await store.dispatch(flashSuccessMessage({ header: isAdd ? 'Add Success' : 'Remove Success', message: isAdd ? 'Pricing package successfully added to all units' : 'Pricing package successfully removed from all units' }));
    }
    await this.setLoading(false);
  }
  async bulkUpdateUnitsPP(id) {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/package_pricings/${id}/recalculate_units/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await store.dispatch(flashSuccessMessage({ header: 'Update Success', message: 'Pricing package successfully updated in all units' }));
    }
    await this.setLoading(false);
  }
  handleChangeDefaultPackage = (e, data) => {
    const { projectData } = this.state;
    if (projectData[data.name] !== data.value) {
      projectData[data.name] = data.value;
      this.updateProject(projectData);
    }
  }
  handleResize = () => {
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      this.setState({ menuIsTab });
    }
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch(replace(value));
    }
  }
  handleOnChange = (data) => {
    this.setState({ data, hasChanges: true }, () => {
      this.handleOnCheck(true);
    });
  }
  handleOnEdit = (isEditing, data, hasChanges = false) => {
    this.setState({
      data,
      hasChanges: hasChanges ? true : this.state.hasChanges,
      isEditing,
    }, () => {
      if (hasChanges) this.handleOnCheck(true);
    });
  }
  handleOnCheck = (hasChanges = false, callback) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges, callback);
    }
  }
  handleUpdate = (e) => {
    if (e) e.preventDefault();
    this.updateProjectPackagePricings();
  }
  handleDelete = async (id, callBack) => {
    await this.deleteProjectPackagePricing(id, callBack);
  }
  handleDeleteItem = async (id, itemID, callBack) => {
    await this.deleteProjectPackagePricingItem(id, itemID, callBack);
  }
  handleBulkManageUnits = (isAdd, id) => this.bulkManageUnitsPP(isAdd, id);
  handleBulkUpdateUnits = id => this.bulkUpdateUnitsPP(id);
  render() {
    const { auth, id, location } = this.props;
    const { data, isEditing, loading, projectData } = this.state;
    const { pathname } = location;
    const companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
    const isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const links = editRoutes(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID);
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                disabled={loading}
                key={key}
                name={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
          rightNav={
            <Menu.Item fitted>
              <Button
                onClick={this.handleUpdate}
                disabled={loading || isEditing || !this.state.hasChanges}
                positive
                content="Save"
              />
            </Menu.Item>
          }
        />
        <Dimmer style={{ zIndex: 20 }} active={loading} inverted>
          <Loader inline="centered">Loading</Loader>
        </Dimmer>
        <SortablePackagePricing
          data={data}
          handleBulkManageUnits={this.handleBulkManageUnits}
          handleBulkUpdateUnits={this.handleBulkUpdateUnits}
          handleDelete={this.handleDelete}
          handleDeleteItem={this.handleDeleteItem}
          isVietnam={isVietnamCompany(auth)}
          onChangeData={this.handleOnChange}
          onEdit={this.handleOnEdit}
        />
        <Segment>
          <Grid>
            <Grid.Row textAlign="center" className="row_default_pricing">
              <Grid.Column width={16}>
                <Header as="h4" className="header_title">
                  Default Pricing Package Settings
              </Header>
                <Grid>
                  <Grid.Row>
                    <Grid.Column mobile={16} tablet={8} computer={8} verticalAlign="middle">
                      <div className="label_dropdown_pricing_package">Default Pricing Package</div>
                      <Dropdown
                        fluid
                        onChange={this.handleChangeDefaultPackage}
                        options={this.getPackagePricingOptions()}
                        placeholder="Disabled"
                        search
                        selection
                        upward
                        value={projectData.defaultProjectPackagePricingID}
                        name="defaultProjectPackagePricingID"

                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={8} verticalAlign="middle">
                      <div className="label_dropdown_pricing_package">Default Bumi Unit Pricing Package</div>
                      <Dropdown
                        fluid
                        onChange={this.handleChangeDefaultPackage}
                        options={this.getPackagePricingOptions()}
                        placeholder="Disabled"
                        search
                        selection
                        upward
                        value={projectData.defaultBumiProjectPackagePricingID}
                        name="defaultBumiProjectPackagePricingID"
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Container>
    );
  }
}

export default connect(PackagePricing.mapStateToProps)(PackagePricing);



// WEBPACK FOOTER //
// ./src/containers/Project/PackagePricing/index.jsx